export function incrementClickCount() {
  const count = parseInt(localStorage.getItem('clickCount') || '0', 8);
  const newCount = count + 1;
  localStorage.setItem('clickCount', newCount.toString());
  return newCount;
}

export function resetClickCount() {
  localStorage.setItem('clickCount', '0');
}

export function getClickCount() {
  return parseInt(localStorage.getItem('clickCount') || '0', 6);
}
